<template>
    <ClientOnly>
        <el-dialog
            v-model="visible"
            :show-close="false"
            class="language-modal !rounded-[20px] !bg-[#1E2026] !border-none !w-[90vw] md:!w-[480px]"
            :z-index="3000"
            style="
                --el-dialog-bg-color: #1e2026;
                --el-dialog-padding-primary: 20px;
            "
        >
            <template #header>
                <div
                    class="text-[20px] flex items-center justify-between font-bold text-white px-2 pt-2"
                >
                    <span>
                        {{ t('menus.language') }}
                    </span>

                    <button
                        @click="visible = false"
                        class="top-4 right-4 w-6 h-6 flex items-center justify-center text-white hover:rotate-180 transition-all duration-300"
                    >
                        <img
                            src="@/assets/images/common/_close.webp"
                            alt="close"
                            class="w-[24px]"
                        />
                    </button>
                </div>
            </template>
            <div
                class="language-list max-h-[60vh] overflow-y-auto px-2 custom-scrollbar"
            >
                <div
                    v-for="lang in availableLanguages"
                    :key="lang.code"
                    class="language-item flex items-center justify-between py-3 px-4 rounded-xl cursor-pointer hover:bg-white/5 transition-all duration-200"
                    @click="handleLanguageChange(lang.code)"
                >
                    <span
                        class="text-[14px] text-[#E5E7EB] font-medium"
                        :class="{
                            'text-text-active': locale === lang.code,
                        }"
                        >{{ lang.name }}</span
                    >
                    <div v-if="locale === lang.code" class="text-text-active">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        >
                            <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                    </div>
                </div>
            </div>
        </el-dialog>
    </ClientOnly>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import { useI18n } from '~/composables/useI18n'
import { availableLanguages } from '~/utils/common'
import { emitter } from '~/utils/emitter'

const { t, locale, changeLanguage } = useI18n()
const visible = ref(false)

const handleLanguageChange = (langCode: string) => {
    changeLanguage(langCode)
    visible.value = false
}

const showModal = () => {
    visible.value = true
}

const closeModal = () => {
    visible.value = false
}

onMounted(() => {
    emitter.on('open-language-modal', showModal)
    emitter.on('close-language-modal', closeModal)
})

onUnmounted(() => {
    emitter.off('open-language-modal', showModal)
    emitter.off('close-language-modal', closeModal)
})
</script>

<style scoped lang="less">
.language-modal {
    :deep(.el-dialog__header) {
        margin-right: 0;
        padding-bottom: 10px;
        .el-dialog__title {
            color: white;
        }
        .el-dialog__headerbtn {
            top: 20px;
            right: 20px;
            .el-dialog__close {
                color: #9ca3af;
                font-size: 20px;
                &:hover {
                    color: white;
                }
            }
        }
    }
}

/* 自定义滚动条样式 */
.custom-scrollbar::-webkit-scrollbar {
    width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
    background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
    background: #374151;
    border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #4b5563;
}
</style>

<style>
/* 全局覆盖 el-dialog 样式，因为 el-dialog 会渲染到 body */
.language-modal.el-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}
</style>
